// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unraid-svg-icon[data-v-f037ac9e]{color:inherit;display:inline-block;vertical-align:middle;fill:currentColor;stroke:none}", ""]);
// Exports
module.exports = exports;
